import {
  TWO_COLUMNS,
  THREE_COLUMNS,
  FOUR_COLUMNS
} from "../../../../state/modules/layout/constants";

const ENABLED_CIDS = [
  4210,
  26090,
  9265,
  28291,
  27111,
  50009,
  19517,
  19517,
  16091,
  5668,
  3606,
  4208,
  5034,
  14274,
  7617,
  18797,
  20831,
  27110,
  25997,
  4616,
  3602,
  4209,
  7078,
  5678,
  6519,
  13210,
  7616,
  20753,
  26776,
  4910,
  20317,
  19855,
  50072,
  5088,
  2640,
  27953,
  4169,
  16793,
  5606,
  18984,
  2238,
  4545,
  13632,
  7657,
  2639,
  4540,
  9263,
  4172,
  4177,
  27108,
  5607,
  19224,
  5813,
  5020,
  21867,
  6046,
  7618,
  2637,
  4175,
  3630,
  11321,
  5021,
  16095,
  28425,
  14312,
  8799,
  9577,
  27999,
  19632,
  2641,
  4896,
  8730,
  26091,
  4174
];
const ENABLED_STORES = ["COM", "US", "FR", "DE"];

const COLUMN_COUNT_TO_PROMO_TILE_POSITION = {
  [TWO_COLUMNS]: 6,
  [THREE_COLUMNS]: 9,
  [FOUR_COLUMNS]: 12
};

export { ENABLED_CIDS, ENABLED_STORES, COLUMN_COUNT_TO_PROMO_TILE_POSITION };
